import {OperatingSystem} from "../api/models";
import {common} from "../i18n";

const icons: Record<OperatingSystem, string> = {
    windows: 'bi-windows',
    macos: 'bi-apple',
    linux: 'bi-tux',
    any: 'bi-box-seam'
};

// The operating system's icon, and its name unless iconOnly (then it's the icon's label).
export function OperatingSystemLabel({os, iconOnly}: { os: OperatingSystem, iconOnly?: boolean }) {
    return iconOnly
        ? <i className={`bi ${icons[os]}`} role="img" aria-label={common.operatingSystems[os]} title={common.operatingSystems[os]}></i>
        : <span className="text-nowrap"><i className={`bi ${icons[os]} me-1`} aria-hidden="true"></i>{common.operatingSystems[os]}</span>;
}

// The visitor's operating system, as far as the browser says.
export function detectOperatingSystem(): OperatingSystem | undefined {
    const platform = `${(navigator as any).userAgentData?.platform ?? ''} ${navigator.userAgent}`.toLowerCase();
    if (/iphone|ipad|android/.test(platform)) return undefined;
    if (/mac/.test(platform)) return 'macos';
    if (/win/.test(platform)) return 'windows';
    if (/linux|x11/.test(platform)) return 'linux';
    return undefined;
}

// A guess from a file's name, for a starting value: .dmg is macOS, .exe Windows, and so on.
export function guessOperatingSystem(fileName: string): OperatingSystem {
    const name = fileName.toLowerCase();
    if (/\.(dmg|pkg)$/.test(name) || /mac|osx|darwin/.test(name)) return 'macos'; // before 'win': darwin
    if (/\.(exe|msi)$/.test(name) || /win/.test(name)) return 'windows';
    if (/\.(deb|rpm|appimage)$/.test(name) || /linux/.test(name)) return 'linux';
    return 'any';
}
